import { createSelector } from 'reselect';
import { activeSelector } from 'selectors/testTarget/offers/updateProductNameDisplayHP/active/activeSelector';
import { isTestTargetReadySelector } from 'viewModel/selectors/testTarget/isTestTargetReadySelector';

/**
 * Returns whether the Update Product Name Display HP should be shown.
 * Depends on the offer `active` field and the TestTarget readiness gate.
 */
const showUpdateProductNameDisplayHPSelector = createSelector(isTestTargetReadySelector, activeSelector, (testReady, active) => testReady && active);

export { showUpdateProductNameDisplayHPSelector };
